export const REQUIRED_OPTION = {
  serviceAlias: null,
  communityApi: null,
};

export const INITIAL_OPTION: IOption = {
  ...REQUIRED_OPTION,
  useLiveKeyword: true,
  useAutoSuggest: true,
  useSearchRefresh: false,
  path: '',
};
